import { render, staticRenderFns } from "./editCliente.vue?vue&type=template&id=6243ba4d&scoped=true"
import script from "./editCliente.vue?vue&type=script&lang=js"
export * from "./editCliente.vue?vue&type=script&lang=js"
import style0 from "./editCliente.vue?vue&type=style&index=0&id=6243ba4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6243ba4d",
  null
  
)

export default component.exports